import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectCreatedByFilter = createSelector(
  [(store: RootState) => store.documentsSignerList.createdByFilter],
  (value) => value
);
